import type { Database } from "@/integrations/supabase/types";

type CodeRow = Database["public"]["Tables"]["codes"]["Row"];

export type Code = CodeRow & {
	owner_email?: string | null;
};

export const normalizeCode = (
	code: CodeRow,
	ownerEmail?: string | null,
): Code => ({
	...code,
	owner_email: ownerEmail ?? null,
});
